export default __webpack_public_path__ + "0c4b0ee.png";